import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/icon-plus.png'


const _withScopeId = n => (_pushScopeId("data-v-2f0eb0fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-social-share" }
const _hoisted_2 = { class: "container main" }
const _hoisted_3 = { class: "box-top-apply-button" }
const _hoisted_4 = { class: "program-purpose" }
const _hoisted_5 = { class: "page-title" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "program-intro" }
const _hoisted_8 = { class: "page-title" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 0,
  class: "box-tab"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "name" }
const _hoisted_15 = {
  key: 1,
  class: "box-collection-items"
}
const _hoisted_16 = {
  key: 1,
  class: "collection-item-text-field"
}
const _hoisted_17 = {
  key: 2,
  class: "map-area"
}
const _hoisted_18 = { class: "page-title" }
const _hoisted_19 = {
  key: 4,
  class: "recycling-guidelines"
}
const _hoisted_20 = { class: "page-title" }
const _hoisted_21 = {
  key: 0,
  class: "box-image"
}
const _hoisted_22 = ["srcset", "media"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "description multiple-line-text" }
const _hoisted_25 = { class: "custom-area" }
const _hoisted_26 = {
  key: 1,
  class: "container"
}
const _hoisted_27 = { class: "brand-info" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "box-text" }
const _hoisted_30 = { class: "page-title" }
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 0,
  src: _imports_0
}
const _hoisted_33 = {
  key: 1,
  class: "social-share"
}
const _hoisted_34 = ["href"]
const _hoisted_35 = ["src"]

import { ref, onMounted, computed, watch } from 'vue';
  import Banner from './components/banner.vue';
  import CollectedItems from './components/collected-items/index.vue';
  import OfflineCollectionPoint from './components/offline-collection-point.vue';
  import ApplyButton from './components/apply-button/index-view.vue';
  import AgeRestricition from './components/age-restricition.vue';
  import { IProgram, TProgramShowType } from '@/types/program';
  import { Location } from './components/google-map.vue';
  import _ from 'lodash';
  import ApplyPage from './components/apply-page/index.vue';
  import { useI18n } from 'vue-i18n';
  import ApplyPdo from './components/apply-pdo.vue';
  import { request } from '@/utils';
  import { PDOType } from '@/types/pdo';
  import { ICompanyAccount } from '@/types/company-account';
  import { authStore } from '@/stores';
  import RichText from './components/richtext.vue';

  export interface IProps {
    program: IProgram
  }interface ITab {
    name: string;
    key: TProgramShowType;
    icon: string;
    activeIcon: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

const props = __props as { program: IProgram }

  ;
  
  onMounted(() => {
    if (authStore.access_token) {
      authStore.tryFetchData();
    }
    getPdos();
    getCompanyAccounts();
  });

  // // 调试用
  // const props = reactive<{ program: IProgram }>({
  //   program: {} as IProgram
  // });
  // onMounted(async () => {
  //   const { request } = require('@/utils/index');
  //   const { data } = await request.get('programs/97');
  //   props.program = data;
  // });
  // // 这句只是在template可以直接用program.xxx 和传进来的props用起来一样
  // const program = computed(() => props.program as IProgram);
  // // 调试用 - 结束

  const pdoLoaded = ref(false);
  const pdos = ref<PDOType[]>([]);
  async function getPdos() {
    try {
      const { data } = await request.get<PDOType[]>('pdos', { params: { page: 0, program_id_eq: props.program?.id, state_eq: 'approved', show_on_map_eq: true } });
      pdos.value = data;
    } finally {
      pdoLoaded.value = true;
    }
  }

  const companyAccountLoaded = ref(false);
  const companyAccounts = ref<ICompanyAccount[]>([]);
  async function getCompanyAccounts() {
    try {
      const { data } = await request.get<ICompanyAccount[]>('company_accounts', { params: { page: 0, program_id_eq: props.program?.id, show_on_map_eq: true } });
      companyAccounts.value = data;
    } finally {
      companyAccountLoaded.value = true;
    }
  }

  const { locale, t } = useI18n();
  const tabs = ref<ITab[]>([]);
  const tabActiveKey = ref<TProgramShowType>();
  const locationList = computed<Location[]>(() => {
    let idStep = 0;
    const programPoints = (props.program?.program_detail_info_attributes?.offline_collection_points || []).map((item) => {
      const location = (item.geographic_coordinates || '').split(',');
      return {
        id: ++ idStep,
        title: item.name,
        address: item.address,
        phoneNumber: item.phone_number,
        lng: location[0] ? Number(location[0]) : undefined,
        lat: location[1] ? Number(location[1]) : undefined,
        postal_code: item.postal_code,
        opening_hours: item.opening_hours,
        show_phone_on_map: true
      };
    });
    const pdoPoints = pdos.value.map((item) => {
      const location = (item.geographic_coordinates || '').split(',');
      return {
        id: ++ idStep,
        title: item.facility_name,
        address: item.street_address,
        phoneNumber: item.phone_number,
        lng: location[0] ? Number(location[0]) : undefined,
        lat: location[1] ? Number(location[1]) : undefined,
        postal_code: item.postal_code,
        opening_hours: item.opening_time,
        pdo: true,
        show_phone_on_map: item.show_phone_on_map
      };
    });
    const companyAccountPoints: Location[] = [];
    companyAccounts.value.map((item) => {
      const address = item.store_address;
      if (address) {
        const location = (address.geographic_coordinates || '').split(',');
        companyAccountPoints.push({
          id: ++ idStep,
          title: item.name,
          address: getCompanyAddress(address),
          phoneNumber: address.phone_number,
          lng: location[0] ? Number(location[0]) : undefined,
          lat: location[1] ? Number(location[1]) : undefined,
          postal_code: address.postal_code,
          show_phone_on_map: true
        });
      }
    });
    return [...programPoints, ...pdoPoints, ...companyAccountPoints].filter(item => !item.address || !item.address?.includes('undefined')); // 若Partner没有设置地址，则不显示再谷歌地图中
  });

  const isJapan = process.env.VUE_APP_COUNTRY === 'ja';
  // 日本环境返回具体地址
  function getCompanyAddress(address: {street_address: string; extended_address: string; region: string; locality: string}) {
    if (isJapan) {
      return (address.region || '') + ' ' + (address.locality || '') + ' ' + address.street_address + ' ' + (address.extended_address || '');
    } else {
      return address.street_address + ' ' + (address.extended_address || '');
    }
  }
  const recyclingGuidelines = computed(() => {
    return _.get(props.program, `program_detail_info_attributes.recycling_guidelines.${tabActiveKey.value}`);
  });
  // 是B2
  const isStoreSub = computed(() => {
    return _.get(authStore.user, 'company_account.role') === 'store_sub';
  });

  const showCollectionButton = computed(() => {
    // B1所有按钮都不显示
    if (_.get(authStore.user, 'company_account.role') === 'store_main') {
      return false;
    }
    return showCollectionButtonApplyButton.value || showParticipateButton.value;
  });

  // 是否显示申请回收按钮
  const showCollectionButtonApplyButton = computed(() => {
    // PDO可以走线上回收（就算没有线上tab）
    if (props.program?.is_pdo_of_program) {
      return true;
    }
    // program配置是否显示回收按钮给B2账号
    if (isStoreSub.value) {
      return props.program.show_collection_btn_to_store_sub;
    }
    if (tabActiveKey.value === 'online') {
       // admin编辑环境下
      if (_.isString(props.program.hide_collection_btn)) {
        return props.program.hide_collection_btn !== 'always';
      }
      // 普通用户和非PDO
      return !props.program?.hide_collection_btn;
    }
    return false;
  });

  // 是否显示参加按钮
  const showParticipateButton = computed(() => {
    // 如果 隐藏收集按钮 = true, 给 B2 显示回收按钮 = true，等于只给B2用户开放这个功能
    if (props.program?.hide_collection_btn && props.program.show_collection_btn_to_store_sub) {
      // B2不显示参加按钮，所以这里不用判断登录用户是不是b2了，直接隐藏
      return false;
    }
    // B2不显示参加按钮
    if (props.program.participation_request_id || isStoreSub.value) {
      return false;
    }
    // 线上一直显示
    if (tabActiveKey.value === 'online') {
      return true;
    }
    // 线下 program.is_offline_collection 存在就显示
    return props.program.is_offline_collection;
  });

  const socialShare = computed(() => {
    const { facebook_url, twitter_url, instagram_url, youtube_url, line_url } = _.get(props.program, 'program_detail_info_attributes.brand_introduction') || {};
    return [
      {
        imageUrl: require('@/assets/icon/footer/facebook-hover.png'),
        link: facebook_url
      },
      {
        imageUrl: require('@/assets/icon/footer/twitter-hover.png'),
        link: twitter_url
      },
      {
        imageUrl: require('@/assets/icon/footer/Instagram-hover.png'),
        link: instagram_url
      },
      {
        imageUrl: require('@/assets/icon/footer/youtube-hover.png'),
        link: youtube_url
      },
      {
        imageUrl: require('@/assets/icon/line.png'),
        link: line_url
      }
    ].filter(item => item.link);
  });

  const tabMap: { [key in TProgramShowType]: ITab } = {
    online: {
      name: t('tab_online_name'),
      key: 'online',
      icon: require('./images/icon-phone.png'),
      activeIcon: require('./images/icon-phone-active.png')
    },
    offline: {
      name: t('tab_offline_name'),
      key: 'offline',
      icon: require('./images/icon-location.png'),
      activeIcon: require('./images/icon-location-active.png')
    }
  };
  watch(
    () => props.program?.program_detail_info_attributes?.show_types?.length,
    () => {
      let val = props.program?.program_detail_info_attributes?.show_types || [];

      // brand = brita 时，tab 显示顺序为 offline / online
      if (props.program?.brand?.toLowerCase() === 'brita') {
        val = (['offline', 'online'] as TProgramShowType[]).filter(key => val.includes(key));
      }
      tabs.value = val.map(key => tabMap[key]);
      if (tabs.value.length) {
        tabActiveKey.value = tabs.value[0]?.key;
      }
    },
    { immediate: true }
  );

return (_ctx: any,_cache: any) => {
  const _component_AppSocialShare = _resolveComponent("AppSocialShare")!

  return (_openBlock(), _createBlock(AgeRestricition, { program: __props.program }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(locale) === 'ja' ? ApplyPage : 'div'), { program: __props.program }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["page", { 'show-fixed-content': __props.program.show_fixed_content, [`lang-${_unref(locale)}`]: true }])
          }, [
            (__props.program.show_fixed_content)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(Banner, {
                    title: __props.program.program_detail_info_attributes?.top_title,
                    description: __props.program.program_detail_info_attributes?.top_sub_title,
                    image: __props.program.program_detail_info_attributes?.top_image?.url,
                    "show-bg-overlay": !__props.program.program_detail_info_attributes?.top_image_gray_layer_off,
                    logos: __props.program.program_detail_info_attributes?.brand_logos
                  }, null, 8, ["title", "description", "image", "show-bg-overlay", "logos"]),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_AppSocialShare, {
                      title: __props.program.share_setting?.share_title || __props.program.name,
                      "image-url": __props.program.share_setting?.share_image?.url || __props.program.image?.url
                    }, null, 8, ["title", "image-url"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      _createVNode(ApplyButton, {
                        program: __props.program,
                        "show-apply-button": _unref(showCollectionButtonApplyButton),
                        "show-participate-button": _unref(showParticipateButton)
                      }, null, 8, ["program", "show-apply-button", "show-participate-button"])
                    ], 512), [
                      [_vShow, __props.program.program_detail_info_attributes?.show_collection_btn_on_top && _unref(showCollectionButton)]
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h4", _hoisted_5, [
                        _createVNode(RichText, {
                          content: __props.program.program_detail_info_attributes?.program_purpose?.title
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(RichText, {
                          content: __props.program.program_detail_info_attributes?.program_purpose?.content
                        }, null, 8, ["content"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h4", _hoisted_8, [
                        _createVNode(RichText, {
                          content: __props.program.program_detail_info_attributes?.program_introduction?.title
                        }, null, 8, ["content"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(RichText, {
                          content: __props.program.program_detail_info_attributes?.program_introduction?.content
                        }, null, 8, ["content"])
                      ])
                    ]),
                    (tabs.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tab.key,
                              class: _normalizeClass(["tab-item", { active: tabActiveKey.value === tab.key }]),
                              onClick: ($event: any) => (tabActiveKey.value = tab.key)
                            }, [
                              _withDirectives(_createElementVNode("img", {
                                src: tab.icon
                              }, null, 8, _hoisted_12), [
                                [_vShow, tabActiveKey.value !== tab.key]
                              ]),
                              _withDirectives(_createElementVNode("img", {
                                src: tab.activeIcon
                              }, null, 8, _hoisted_13), [
                                [_vShow, tabActiveKey.value === tab.key]
                              ]),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(tab.name), 1)
                            ], 10, _hoisted_11))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(_).get(__props.program, 'program_detail_info_attributes.collected_items.length') || __props.program.program_detail_info_attributes?.collected_item_text_field)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_unref(_).get(__props.program, 'program_detail_info_attributes.collected_items.length'))
                            ? (_openBlock(), _createBlock(CollectedItems, {
                                key: 0,
                                items: __props.program.program_detail_info_attributes?.collected_items
                              }, null, 8, ["items"]))
                            : _createCommentVNode("", true),
                          (__props.program.program_detail_info_attributes?.collected_item_text_field)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(RichText, {
                                  class: "description",
                                  content: __props.program.program_detail_info_attributes?.collected_item_text_field
                                }, null, 8, ["content"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ display: _unref(showCollectionButton) ? 'block' : 'none' })
                    }, [
                      _createVNode(ApplyButton, {
                        program: __props.program,
                        "show-apply-button": _unref(showCollectionButtonApplyButton),
                        "show-participate-button": _unref(showParticipateButton)
                      }, null, 8, ["program", "show-apply-button", "show-participate-button"])
                    ], 4),
                    (tabActiveKey.value === 'offline' && _unref(locationList).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("h4", _hoisted_18, _toDisplayString(_unref(t)('offline_collection_point_title')), 1),
                          (pdoLoaded.value && companyAccountLoaded.value)
                            ? (_openBlock(), _createBlock(OfflineCollectionPoint, {
                                key: 0,
                                "location-list": _unref(locationList)
                              }, null, 8, ["location-list"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.program.program_detail_info_attributes?.show_pdo_btn)
                      ? (_openBlock(), _createBlock(ApplyPdo, {
                          key: 3,
                          program: __props.program
                        }, null, 8, ["program"]))
                      : _createCommentVNode("", true),
                    (_unref(recyclingGuidelines))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("h4", _hoisted_20, _toDisplayString(_unref(recyclingGuidelines)?.title), 1),
                          (_unref(recyclingGuidelines)?.image_pc || _unref(recyclingGuidelines)?.image_mo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("picture", null, [
                                  (_unref(recyclingGuidelines)?.image_mo)
                                    ? (_openBlock(), _createElementBlock("source", {
                                        key: 0,
                                        srcset: _unref(recyclingGuidelines)?.image_mo,
                                        media: `(max-width: ${576}px)`
                                      }, null, 8, _hoisted_22))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("img", {
                                    src: _unref(recyclingGuidelines)?.image_pc
                                  }, null, 8, _hoisted_23)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(recyclingGuidelines)?.content), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            (__props.program.show_fixed_content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      class: "cover",
                      src: __props.program.program_detail_info_attributes?.brand_introduction?.image
                    }, null, 8, _hoisted_28),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("h5", _hoisted_30, _toDisplayString(__props.program.program_detail_info_attributes?.brand_introduction?.title), 1),
                      _createVNode(RichText, {
                        class: "description",
                        content: __props.program.program_detail_info_attributes?.brand_introduction?.content
                      }, null, 8, ["content"]),
                      (__props.program.program_detail_info_attributes?.brand_introduction?.intro_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: __props.program.program_detail_info_attributes?.brand_introduction?.intro_url,
                            target: "_blank",
                            class: "button"
                          }, [
                            _createTextVNode(_toDisplayString(__props.program.program_detail_info_attributes?.brand_introduction?.intro_btn_text) + " ", 1),
                            (_unref(locale) !== 'ja')
                              ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      (_unref(socialShare).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialShare), (item, index) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: index,
                                href: item.link,
                                target: "_blank"
                              }, [
                                _createElementVNode("img", {
                                  src: item.imageUrl
                                }, null, 8, _hoisted_35)
                              ], 8, _hoisted_34))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 3
      }, 8, ["program"]))
    ]),
    _: 3
  }, 8, ["program"]))
}
}

})